import React from "react";
import "./Plans.css";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";

// Import de imagenes
// import img1 from "../../assets/gym1.jpeg";
// import img2 from "../../assets/gym2.jpeg";
import img3 from "../../assets/gym3.jpg";
// import meses3 from "../../assets/3meses.jpeg";
// import meses6 from "../../assets/6meses.jpeg";
// import meses12 from "../../assets/12meses.jpeg";
// import wht from "../../assets/wht.png"
// import mp from "../../assets/mp.png"
import iconos from "../../assets/iconos.png"

const Plans = () => {
  // const [show, setShow] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <>
      <div className="container-p" id="plans">
        <Container fluid className="text-center container">
          <h2 className="fs-1 fw-bold text-light">PLANES</h2>
          <Row className="mt-5 align-items-stretch justify-content-center grid-p">
            <Col className="d-flex align-items-center justify-content-center sub-grid-p">
              <Card style={{ width: "20rem" }} className="card-scale shadow">
                <Card.Img variant="top" src={img3} />
                <Card.Body>
                  <Card.Title>Chequeo Total</Card.Title>
                  <Card.Text className="fs-4 fw-bold">4000$</Card.Text>
                  <Button
                    className="btn-p fw-bold"
                    href="https://wa.me/+59893961919"
                    target="_blank"
                  >
                    QUIERO EL SERVICIO!
                  </Button>
                </Card.Body>
              </Card>
              {/* <Modal
                show={show}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title className="text-center fw-bold">
                    Chequeo Total
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="d-flex align-items-start justify-content-start">
                    <p>Quiero consultar por whatsapp</p>
                    <a
                      href="https://wa.me/+59893961919"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image src={wht} roundedCircle className="wht-m" />
                    </a>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-start">
                    <p>Quiero contratar ya el servicio!</p>
                    <p className="mt-modal">
                      Escanea este codigo de Mercado Pago:
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <Image src={mp} />
                  </div>
                </Modal.Body>
              </Modal> */}
            </Col>
            <Col className="d-flex align-items-center justify-content-center p-4">
              <div className="contain-p w-100 rounded d-flex flex-column align-items-start justify-content-center">
                <div className="separator1"></div>
                <div className="d-flex align-items-center justify-content-center w-100">
                  <p className="fw-bold pt-5 ps-1 pe-1 text-center text-dark w-100">
                    ¿Queres comprar un vehiculo usado con la misma tranquilidad
                    que comprarias un 0km?
                  </p>
                </div>
                <p className="text-center ps-3 pe-3  text-dark w-100">
                  Nuestro servicio pre-compra te brindara esa tranquilidad.
                  Identificamos cualquier tipo de falla, desgaste e imperfeccion
                  que pueda llegar a tener el vehiculo, esto hara que tu
                  experiencia de compra sea segura y sin sorpresas.
                </p>
                <p className="text-center ps-3 pe-3 text-dark w-100">
                  Nuestro servicio incluye:
                </p>
                <ul className="text-text-center ps-3 pe-3 text-dark w-100">
                  <li>
                    -Chequeo electronico mediante scanner de ultima generacion
                  </li>
                  <li>-Deteccion de fallas ocultas</li>
                  <li>-Control ABS y sistema de frenos</li>
                  <li>-Chequeo de caja automatica</li>
                  <li>-Control de carroceria mediante micrometro</li>
                </ul>
                <p className="text-text-center ps-3 pe-3 text-dark w-100">
                  Somos 100% imparciales, quedate tranquilo sabiendo lo que
                  compras.
                </p>
                <p className="text-text-center ps-3 pe-3 text-dark w-100">
                  Te enviamos un informe, fotos y videos de todos los detalles.
                </p>
                <div className="d-flex align-items-center justify-content-center w-100">
                  <p className="text-center fw-bold pb-5  text-dark">
                    ¡No te muevas de tu casa! <br />
                    Nos desplazamos por ti para revisar el vehiculo que quieras
                    comprar.
                  </p>
                </div>
                <div className="separator2"></div>
              </div>
            </Col>
          </Row>
          <p className="text-center text-light fw-semibold fs-4 mt-5 ps-3 pe-3">
            Metodos de Pago: Débito, Crédito, Transferencia o Efectivo
          </p>
          <div className="d-flex align-items-start justify-content-center">
            <Image src={iconos} className="iconos-p" />
          </div>
        </Container>
      </div>
    </>
  );
};

export default Plans;
